var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "6"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                height: "100%"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "body-1 mb-3 text-left"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            size: "24",
                            color: "primary"
                          }
                        },
                        [_vm._v("mdi-account-card-details")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-2"
                        },
                        [_vm._v("Server Information")]
                      )
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c("div", [
                        _c(
                          "p",
                          {
                            staticClass: "ma-0"
                          },
                          [
                            _c(
                              "b",
                              {
                                staticClass: "pr-1"
                              },
                              [_vm._v("Server Status:")]
                            ),
                            _c(
                              "v-icon",
                              {
                                staticClass: "mb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(this.serverStatus)
                                }
                              },
                              [_vm._v(" mdi-circle ")]
                            ),
                            _c("span", {
                              staticClass: "ma-0 text-capitalize",
                              domProps: {
                                innerHTML: _vm._s(_vm.serverStatus)
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "ma-0"
                          },
                          [
                            _c(
                              "b",
                              {
                                staticClass: "pr-1"
                              },
                              [_vm._v("Server Hostname:")]
                            ),
                            _vm._v(" " + _vm._s(_vm.hosting_detail.url) + " ")
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "6"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "text-center pa-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "body-1 mb-3 text-left"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            size: "24",
                            color: "primary"
                          }
                        },
                        [_vm._v("mdi-harddisk")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-2"
                        },
                        [_vm._v("Disk Space Usage")]
                      )
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-progress-circular",
                            {
                              attrs: {
                                size: 70,
                                rotate: -90,
                                width: 10,
                                value: _vm.spaceUsedPercent,
                                color: "primary"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.spaceUsedPercent) + "% ")]
                          ),
                          _c("p", {
                            staticClass: "mt-1 mb-0",
                            domProps: {
                              innerHTML: _vm._s(_vm.spaceUsed)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "6"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "text-center pa-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "body-1 mb-3 text-left"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            size: "24",
                            color: "primary"
                          }
                        },
                        [_vm._v("mdi-memory")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-2"
                        },
                        [_vm._v("Memory Usage")]
                      )
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-progress-circular",
                            {
                              attrs: {
                                size: 70,
                                rotate: -90,
                                width: 10,
                                value: _vm.memUsagePercent,
                                color: "primary"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.memUsagePercent) + "% ")]
                          ),
                          _c("p", {
                            staticClass: "mt-1 mb-0",
                            domProps: {
                              innerHTML: _vm._s(_vm.memUsage)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "6"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "text-center pa-3"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "body-1 mb-3 text-left"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "pb-1",
                          attrs: {
                            size: "24",
                            color: "primary"
                          }
                        },
                        [_vm._v("mdi-upload")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-2"
                        },
                        [_vm._v("Bandwidth Usage")]
                      )
                    ],
                    1
                  ),
                  !_vm.loading
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-progress-circular",
                            {
                              attrs: {
                                size: 70,
                                rotate: -90,
                                width: 10,
                                value: _vm.bandwidthPercent,
                                color: "primary"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.bandwidthPercent) + "% ")]
                          ),
                          _c("p", {
                            staticClass: "mt-1 mb-0",
                            domProps: {
                              innerHTML: _vm._s(_vm.bandwidthUsage)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }